import { Message } from 'element-ui'

export function copyText(text, label) {
  const v = String(text || '').trim()
  if (!v) return
  const ok = () => Message.success((label || '内容') + '已复制')
  const fail = () => Message.warning('复制失败')
  if (navigator.clipboard && navigator.clipboard.writeText) {
    navigator.clipboard.writeText(v).then(ok).catch(() => fallbackCopy(v, ok, fail))
    return
  }
  fallbackCopy(v, ok, fail)
}

function fallbackCopy(v, ok, fail) {
  const ta = document.createElement('textarea')
  ta.value = v
  ta.setAttribute('readonly', 'readonly')
  ta.style.position = 'fixed'
  ta.style.left = '-9999px'
  document.body.appendChild(ta)
  ta.select()
  try {
    document.execCommand('copy')
    ok()
  } catch (e) {
    fail()
  }
  document.body.removeChild(ta)
}
